function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { PlayerState } from '../../../core/player/player-state';
import { sdkLogger } from '../../../logger';
import { JsonUtils } from '../../../utils/json-utils';
export var STALL_DETECTION_THRESHOLD_MS = 5000;
var STALL_SKIP = 1.0;
export var ShakaStallDetector = /*#__PURE__*/ function() {
    "use strict";
    function ShakaStallDetector(config) {
        var _this = this;
        _class_call_check(this, ShakaStallDetector);
        _define_property(this, "config", void 0);
        _define_property(this, "stallDetectedTimeout", void 0);
        _define_property(this, "prevPosition", void 0);
        _define_property(this, "prevState", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "captureStats", void 0);
        _define_property(this, "stallDetectedHandler", void 0);
        _define_property(this, "externalDependencies", void 0);
        _define_property(this, "destroy", void 0);
        _define_property(this, "handleStalled", void 0);
        this.config = config;
        this.stallDetectedTimeout = 0;
        this.prevPosition = null;
        this.prevState = null;
        this.logger = sdkLogger.withContext('[ ShakaStallDetector ]');
        this.externalDependencies = function(deps) {
            if (deps === null || deps === void 0 ? void 0 : deps.captureStats) {
                _this.captureStats = deps.captureStats;
            }
        };
        this.destroy = function() {
            clearTimeout(_this.stallDetectedTimeout);
            _this.stallDetectedTimeout = 0;
            _this.prevPosition = null;
            _this.prevState = null;
            _this.logger = undefined;
        };
        this.handleStalled = function() {
            var capturedStats = _this.captureStats ? ", with stats ".concat(JsonUtils.stringify(_this.captureStats())) : '';
            _this.logger.breadcrumb("Shaka player stalled in ".concat(PlayerState[_this.prevState], " state, at position: ").concat(_this.prevPosition).concat(capturedStats));
            if (_this.config.enableStallRecovery && _this.stallDetectedHandler && typeof _this.prevPosition === 'number') {
                var targetTime = _this.prevPosition + STALL_SKIP;
                _this.logger.breadcrumb("Attempting stall recovery by seeking to ".concat(targetTime));
                _this.stallDetectedHandler(targetTime);
            }
        };
    }
    _create_class(ShakaStallDetector, [
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {
                this.prevState = state;
                this.restartTimeout();
            }
        },
        {
            key: "handlePositionChanged",
            value: function handlePositionChanged(position) {
                if (this.prevPosition !== position) {
                    this.restartTimeout();
                }
                this.prevPosition = position;
            }
        },
        {
            key: "onStallDetected",
            value: function onStallDetected(stallDetectedHandler) {
                this.stallDetectedHandler = stallDetectedHandler;
            }
        },
        {
            key: "restartTimeout",
            value: function restartTimeout() {
                clearTimeout(this.stallDetectedTimeout);
                if (this.prevState === PlayerState.Playing) {
                    this.stallDetectedTimeout = self.setTimeout(this.handleStalled, STALL_DETECTION_THRESHOLD_MS);
                }
            }
        }
    ]);
    return ShakaStallDetector;
}();

//# sourceMappingURL=shaka-stall-detector.js.map